import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import { useApolloClient } from '@apollo/client';

import Button from '../../../Button/Button';
import { post } from '../../../../util/request';
import { platform_base_url } from '../../../../util/config';
import { completeAuthentication } from '../../Authentication.utils';

import * as Styled from './UpdatePasswordForm.styled';

/**
 * Update Password Form allows a user to submit a new password for their account
 */
const UpdatePasswordForm = ({ onComplete, email }) => {
  const client = useApolloClient();
  const [isFetching, setIsFetching] = useState(false);

  const handleSubmit = async ({ password }, { setErrors }) => {
    setIsFetching(true);

    await post(
      `${platform_base_url}/v2/identity/reset-password`,
      {
        password
      },
      { credentials: 'include' }
    )
      .then(completeAuthentication.bind(null, client))
      .then(onComplete)
      .catch((e) => {
        setIsFetching(false);
        const error = e?.response?.errors?.[0];

        setErrors({
          password:
            error?.title || 'Unable to contact server. Please try again.'
        });
      });
  };

  return (
    <Styled.UpdatePasswordForm>
      <Styled.Heading>
        Create a new password for <Styled.Emphasis>{email}</Styled.Emphasis>.
      </Styled.Heading>
      <Formik initialValues={{ password: '' }} onSubmit={handleSubmit}>
        <Form>
          <Styled.PasswordInput
            id="UpdatePasswordFormPassword"
            name="password"
            label="Password"
            autoComplete="new_password"
            withRequirements
          />
          <Button
            isFull
            type="submit"
            size="large"
            variant="primary"
            isLoading={isFetching}
          >
            Save Password
          </Button>
        </Form>
      </Formik>
    </Styled.UpdatePasswordForm>
  );
};

UpdatePasswordForm.propTypes = {
  /**
   * email address associated with the account
   */
  email: PropTypes.string.isRequired,
  /**
   * A function that is called upon successful password submission.
   */
  onComplete: PropTypes.func.isRequired
};

export default UpdatePasswordForm;
